module.exports = __webpack_public_path__ + "img/paperclip.b4b66336.svg";